import { render, staticRenderFns } from "./LinkTenantSettingActionLink.vue?vue&type=template&id=67424592&scoped=true"
import script from "./LinkTenantSettingActionLink.vue?vue&type=script&lang=js"
export * from "./LinkTenantSettingActionLink.vue?vue&type=script&lang=js"
import style0 from "./LinkTenantSettingActionLink.vue?vue&type=style&index=0&id=67424592&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67424592",
  null
  
)

export default component.exports